// @ts-ignore
import html2pdf from "html2pdf.js";

export const downloadPDF = async (
  componentRef: React.MutableRefObject<HTMLDivElement>,
  name: string
) => {
  const element = componentRef.current;
  const opt = {
    filename: `${name}.pdf`,
    margin: [0.1, 0, 0.1, 0],
    image: { type: "jpeg", quality: 0.95 },
    html2canvas: {
      scale: 0.97,
      allowTaint: false,
      useCORS: true,
      proxy: "/"
    },
    jsPDF: { unit: "mm", format: "a4", orientation: "landscape" }
    
  };

  await html2pdf().set(opt).from(element).save();
};
